<template>
  <div>
    <transition name="fade-bottom">
      <div v-if="active" class="cookies-bar" :style="{ background: primaryColor }">
        <div class="message">
          <p :style="{ color: secondaryColor }">{{ texts[lang].messageText }} <button type="button" class="link-underline" @click="$modal.show(modalPolicyId ?? 'modal-policy')">{{ texts[lang].messageButton }}</button>.
          </p>
        </div>

        <div class="buttons">
          <button type="button" @click="acceptAll" class="btn" :style="{ color: secondaryColor }">{{ texts[lang].messageBtnConfirm }}</button>
          <button type="button" @click="$modal.show('modal-cookies', { backdrop: 'static' })" class="btn-underline" :style="{ color: secondaryColor, borderColor: secondaryColor }">{{ texts[lang].messageBtnChange }}</button>
        </div>
      </div>
    </transition>

    <div id="modal-cookies" class="modal fade" tabindex="-1" aria-labelledby="modal-cookies-label" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-body-content">
              <p class="cookies-title" :style="{ color: primaryColor }">{{ texts[lang].settingsTitle }}</p>

              <button v-for="cookie in cookies" type="button" class="btn-accept-decline" :class="{ 'accept': cookiesOptions[cookie.label], 'decline': !cookiesOptions[cookie.label] }" @click="changeCookieOpt(cookie.label)" :disabled="cookie.disabled">
                <p v-if="viewportWidth < 700" class="cookie-title" :style="{ color: primaryColor }">{{ cookie.title[lang] }}</p>

                <div class="btn-accept-decline-switch" :style="{ borderColor: primaryColor, color: primaryColor }">
                  <span class="switch-bg" :style="{ backgroundColor: primaryColor }"></span>
                  <span class="switch-label switch-label-left">{{ texts[lang].on }}</span>
                  <span class="switch-label switch-label-right">{{ texts[lang].off }}</span>
                </div>

                <div :class="{ 'ms-3': viewportWidth >= 700 }">
                  <p v-if="viewportWidth >= 700" class="cookie-title" :style="{ color: primaryColor }">{{ cookie.title[lang] }}</p>
                  <p class="cookie-descr">{{ cookie.descr[lang] }}</p>
                </div>
              </button>

              <div class="btn-save-wrapper">
                <button type="button" class="btn-save-cookies" :style="{ background: primaryColor, color: secondaryColor }" data-bs-dismiss="modal" @click="sendCookiesSelection()">{{ texts[lang].btnSave }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!modalPolicyId" id="modal-policy" class="modal fade" tabindex="-1" aria-labelledby="modal-policy-label" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header mb-3">
            <button type="button" class="btn-modal-close" @click="$modal.hide('modal-policy')">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.54 22.53">
                <polygon points="22.54 1.41 21.13 0 11.27 9.85 1.42 0 0 1.41 9.86 11.26 0 21.12 1.42 22.53 11.27 12.68 21.13 22.53 22.54 21.12 12.69 11.26 22.54 1.41" fill="#fff" />
              </svg>
            </button>
          </div>

          <div class="modal-body">
            <div class="modal-body-content">
              <slot name="policies">
                <p class="cookies-title" :style="{ color: primaryColor }">{{ texts[lang].policyTitle }}</p>
                <div class="cookies-text" v-html="texts[lang].policyDescr"></div>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import cookies from './cookies.json';
import texts from './texts.json';
import axios from 'axios';
import { inject } from 'vue';
const { active } = inject('$cookiesBar');

const _getCsrfTokenUrl = '/' + window.Laravel.code + '/get/csrf';
const _setCookiesPref = '/' + window.Laravel.code + '/set/cookies/pref';

const props = defineProps({
  lang: {
    type: String,
    required: false,
    default: 'en'
  },
  texts: {
    type: Object,
    required: false,
    default: texts
  },
  primaryColor: {
    type: String,
    required: false,
    default: "#000"
  },
  secondaryColor: {
    type: String,
    required: false,
    default: "#fff"
  },
  cookiesopt: {
    type: Object,
    required: false,
    default: cookies
  },
  modalPolicyId: {
    type: String,
    required: false,
    default: null
  },
});

import { ref } from 'vue';

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

const frequencyCookieExpired = () => {
  return (getCookie('showCookiesBar') == null || getCookie('showCookiesBar') === true)
}

active.value = frequencyCookieExpired();
const cookiesOptions = ref(props.cookiesopt);

const acceptAll = () => {
  Object.keys(cookiesOptions.value).forEach(key => {
    cookiesOptions.value[key] = true;
  });

  sendCookiesSelection();
}

const sendCookiesSelection = () => {
  axios.get(_getCsrfTokenUrl)
    .then(response => {
      var _token = response.data._token;

      axios.defaults.headers.common = { 'X-Requested-With': 'XMLHttpRequest', 'X-CSRF-TOKEN': _token };

      axios
        .post(_setCookiesPref, cookiesOptions.value)
        .then(function (success) {
          try {
            gtag('consent', 'update', {
              // Standard
              'functionality_storage': cookiesOptions.value['necessary'] ? 'granted' : 'denied',
              // Analytics
              'analytics_storage': cookiesOptions.value['statistics'] ? 'granted' : 'denied',
              // Ads
              'ad_storage': cookiesOptions.value['marketing'] ? 'granted' : 'denied',
              'ad_user_data': cookiesOptions.value['marketing'] ? 'granted' : 'denied',
              'ad_personalization': cookiesOptions.value['marketing'] ? 'granted' : 'denied',
              'personalization_storage': cookiesOptions.value['marketing'] ? 'granted' : 'denied',
              'security_storage': cookiesOptions.value['marketing'] ? 'granted' : 'denied',
            });
          } catch (error) {
            console.error(error)
          }
        }, function (error) {
          console.error(error);
        })
    })
    .catch(error => {
      console.error(error);
    })
    .finally(() => {
      closeCookiesBar();
    });
}

const setFrequencyCookie = (value, days = 30) => {
  const today = new Date();
  const expireDate = new Date(today.setDate(today.getDate() + days));
  document.cookie = `showCookiesBar=false; expires=${expireDate}`;
}

const closeCookiesBar = () => {
  active.value = false;
  setFrequencyCookie(true);
}

const changeCookieOpt = (label) => {
  if (label) {
    cookiesOptions.value[label] = !cookiesOptions.value[label];
  }
}

////////////////// Handle resize
import { onUnmounted } from 'vue';
const viewportWidth = ref(window.innerWidth);
const onResize = () => {
  viewportWidth.value = window.innerWidth;
}

window.addEventListener("resize", onResize, { passive: true });

onUnmounted(() => {
  window.removeEventListener("resize", onResize)
});

</script>

<style lang="scss">
.fade-bottom-enter-active,
.fade-bottom-leave-active {
  transition: opacity 250ms ease-in-out, transform 250ms ease-in-out;
}

.fade-bottom-enter,
.fade-bottom-leave-to {
  opacity: 0;
  transform: translateY(100%);
}

.modal-body-content {
  background-color: #fff;
  padding: 40px 20px 100px;
  box-shadow: 0px -10px 20px rgba(#000, 0.3);
}

.cookies-bar {
  position: fixed;
  bottom: 0px;
  left: 0;
  right: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 15px 10px 5px;
  z-index: 1000;
  box-shadow: 0px -10px 20px rgba(#000, 0.3);

  .message {
    p {
      font-size: 12px;
      letter-spacing: 0.025rem;
      text-align: center;

      button {
        color: #fff;
        text-decoration-color: #fff !important;
      }
    }
  }

  .buttons {
    margin: 10px 15px;
    text-align: center;

    .btn {
      border-width: 1px;
      border-style: solid;
      font-size: 0.725rem;
      padding: 10px 15px;
      line-height: 1;
      margin: 5px 15px;
    }

    .btn-underline {
      text-decoration: underline;
      background: transparent;
      font-size: 12px;

      &:hover {
        text-decoration: none;
      }
    }
  }
}

.cookies-title {
  text-align: center;
  font-size: 24px;
  margin-bottom: 10px;
}

.cookies-text {
  color: #000;

  p {
    font-size: 12px;
  }
}

.btn-accept-decline {
  margin-bottom: 40px;
  position: relative;
  display: flex;
  align-items: center;
  flex-flow: column;

  .btn-accept-decline-switch {
    position: relative;
    border: 1px solid;
    border-radius: 34px;
    transition: 400ms;
    display: flex;
    align-items: center;

    .switch-bg {
      position: absolute;
      z-index: 0;
      left: 0%;
      top: 50%;
      transform: translateY(-50%);
      width: 50%;
      height: 100%;
      border-radius: 34px;
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
      transition: left 250ms ease-in-out;
    }

    .switch-label {
      padding: 8px 5px;
      width: 50px;
      font-size: 13px;
      line-height: 1;
      text-align: center;
      position: relative;
      z-index: 1;
      transition: color 250ms ease-in-out;
    }
  }

  .cookie-title {
    line-height: 1.2;
    font-size: 14px;
    letter-spacing: 0;
    margin-bottom: 10px;
  }

  .cookie-descr {
    margin-top: 10px;
    line-height: 1.5;
    font-size: 11px;
    color: #000;
  }

  &.accept {
    .btn-accept-decline-switch {
      .switch-label.switch-label-left {
        color: #fff;
      }
    }
  }

  &.decline {
    .btn-accept-decline-switch {
      .switch-bg {
        left: 50%;
      }
    }

    .btn-accept-decline-switch {
      .switch-label.switch-label-right {
        color: #fff;
      }
    }
  }

  &:disabled {
    .btn-accept-decline-switch {
      opacity: 0.4;
    }
  }
}

.btn-discard-cookies {
  text-align: center;

  i {
    color: #000;

    &::before {
      font-size: 40px;
    }
  }

  span {
    display: block;
    color: #000;
    letter-spacing: 0.025rem;
    line-height: 1;
    font-size: 0.75rem;
  }
}

.btn-save-wrapper {
  text-align: center;

  .btn-save-cookies {
    font-size: 0.9375rem;
    font-weight: 400;
    padding: 18px 54px 22px;
    border-radius: 50px;
    transition: opacity 250ms ease-in-out;

    &:hover {
      background: transparent;
      opacity: 0.6;
    }
  }
}

#modal-policy {
  .btn-modal-close {
    svg {
      width: 20px;
    }
  }
}

@media only screen and (min-width: 700px) {
  .modal-body-content {
    padding: 40px 40px 100px;
  }

  .cookies-bar {
    bottom: 0px;
  }

  .btn-accept-decline {
    flex-flow: row;
    text-align: left;
  }
}

@media only screen and (min-width: 1200px) {
  .modal-body-content {
    padding: 40px 60px 60px;
  }

  .cookies-bar {
    box-shadow: 0px 0px 20px rgba(#000, 0.3);
    right: unset;
    left: 50%;
    transform: translateX(-50%);
    bottom: 10px;
    max-width: 560px;
    padding: 20px 20px 10px;
  }

  .cookies-title {
    font-size: 30px;
    margin-bottom: 30px;
  }

  .cookies-text {
    p {
      font-size: 14px;
    }
  }

  .btn-accept-decline {
    margin-bottom: 60px;

    .cookie-title {
      font-size: 18px;
    }

    .btn-accept-decline-switch {
      .switch-label {
        font-size: 15px;
        padding: 12px 5px;
        width: 70px;
      }
    }
  }
}
</style>